export default __webpack_public_path__ + "static/media/bot-icon.78e28d68.png";